module.exports = __webpack_public_path__ + "static/media/file.63f908ec.svg";